<template>
  <div id="app">
    <link rel="stylesheet"
      href="https://cdn-gbbu02.graphibox.eu/builds/fonts/fontawesome-v5.12.0/fonts-fontawesome.all.min.css" defer />

    <div id="nav" v-if="showMenu == true || windowWidth > 1000" @click="hideMenuPhone()">
      <div>
        <router-link to="/nos-hebergements" title="Voir tous nos hébergements">Hébergements</router-link>
        <span>|</span>
        <router-link to="/votre-sejour" title="Organiser votre séjour dans le Gers">Votre séjour</router-link>
        <span>|</span>
        <!-- <a href="/tarifs-et-reservation" title="Tarifs et réservation de nos gîtes">Tarifs &
          réservations</a> -->
      </div>

      <router-link to="/" title="Accueil" class="centerLogo">
        <img alt="Vue logo" src="@/assets/images/aerodrome/logo-avion.png" id="imgLogo" v-if="isAerodrome()" />
        <img alt="Vue logo" src="@/assets/logo.png" id="imgLogo" v-else />
      </router-link>

      <div>
        <!-- <router-link to="/epicerie" class="epi"
          title="L'épicerie itinérante et traditionnelle de Nanou">L'épicerie</router-link> -->
        <a href="/tarifs-et-reservation" title="Tarifs et réservation de nos gîtes">Tarifs &
          réservations</a>
        <span>|</span>
        <router-link to="/actualites" title="Toutes nos actualités"
          v-if="$store.state.gbbuArticles">Actualités</router-link>
        <span v-if="$store.state.gbbuArticles">|</span>
        <router-link to="/contact" title="Contactez-nous">Contact</router-link>
        <router-link title="Accueil" to="/">
          <i class="far fa-home"></i>
        </router-link>
      </div>
    </div>

    <PhoneBurger :menu.sync="showMenu"></PhoneBurger>
    <router-link to="/" class="phoneLogo" title="accueil">
      <img alt="Vue logo" src="@/assets/logo.png" />
    </router-link>

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <footer>
      <section>
        <div>
          <h4>Menu</h4>
          <ul>
            <li>
              <router-link to="/nos-hebergements" title="Tous nos Hébergements ">Hébergements</router-link>
            </li>
            <li>
              <router-link to="/votre-sejour" title="Organiser votre séjour ">Votre séjour</router-link>
            </li>
            <li>
              <router-link to="/tarifs-et-reservation" title="Tarifs et réservations de nos gîtes">Tarifs et
                réservations</router-link>
            </li>
            <li>
              <router-link to="/actualites" title="Actualités" v-if="$store.state.gbbuArticles">Actualités</router-link>
            </li>
            <li>
              <router-link to="/aerodrome" title="Aérodrome à Touget">Aérodrome</router-link>
            </li>
            <li>
              <router-link class="greenLink" to="/contact" title="Contactez nous">Contact</router-link>
            </li>
          </ul>
        </div>

        <div>
          <h4>Nous situer</h4>
          <p>
            Famille Oulé
            <br />
            {{ $store.state.globalData.name }}
            <br />
            {{ $store.state.globalData.codePostal }}
            {{ $store.state.globalData.ville }}
            <br />
            <!-- tél.
            {{ $store.state.globalData.telephone }}
            <br /> -->
            port.
            {{ $store.state.globalData.telephonePortable }}
          </p>

          <router-link class="greenLink" to="/contact" title="Comment nous trouver ">Situation</router-link>
        </div>

        <div>
          <h4>Nos partenaires</h4>
          <ul>
            <li>
              <a href="http://www.tourisme-3cag-gers.com/" target="_blank" rel="noopener noreferrer"
                name="Office de tourisme de Gimont">Office de tourisme de Gimont</a>
            </li>
            <li>
              <a href="https://www.tourisme-bastidesdelomagne.fr/" target="_blank" rel="noopener noreferrer"
                name="Office de tourisme de Mauvezin">Office de tourisme de Mauvezin</a>
            </li>
            <li>
              <a href="https://safrandenmarre.com/accueil.php" target="_blank" rel="noopener noreferrer"
                name="Safran d'En Mare">Safran d'En Mare</a>
            </li>
            <li>
              <a href="https://www.gers-gites-france.com/" target="_blank" rel="noopener noreferrer"
                name="Loisirs Accueil Gers">Loisirs Accueil Gers</a>
            </li>
            <li>
              <a href="http://domaine-de-bile.com/" target="_blank" rel="noopener noreferrer" name="Le Domaine de Bilé">Le
                Domaine de Bilé</a>
            </li>
            <li>
              <a href="https://www.gersementbon.fr/" target="_blank" rel="noopener noreferrer"
                name="La Ferme en Cagolin">La Ferme en Cagolin</a>
            </li>
            <li>
              <a href="http://www.cotegers.fr/" target="_blank" rel="noopener noreferrer"
                name="Gascogne Côté Gers">Gascogne Côté Gers</a>
            </li>
          </ul>
        </div>
      </section>

      <div class="logosPartner">
        <a href="https://www.gites-de-france.com/fr" target="_blank" rel="noopener" title="gite de france">
          <img src="@/assets/images/logos/gitefrance.png" alt="gite de france  logo" />
        </a>
        <a href="http://www.vrai.tourisme-gers.com/" target="_blank" rel="noopener" name="Terra gers">
          <img src="@/assets/images/logos/terra-gers.png" alt=" terra gers logo" />
        </a>
        <a href="https://www.ancv.com/" target="_blank" rel="noopener" title="ANCV">
          <img src="@/assets/images/logos/ANCV.png" alt=" ancv  logo" />
        </a>

        <a href="http://www.tourisme-handicaps.org/articles/" target="_blank" rel="noopener" title="tourisme handicap">
          <img src="@/assets/images/logos/Logo-Tourisme-Handicap.png" alt=" logo tourisme handicap" />
        </a>
      </div>
      <div class="copyright">
        <p>® {{ new Date().getFullYear() }} Gîte d'en Lébé</p>

        <a title="page facebook"
          href="https://www.facebook.com/G%C3%AEte-dEn-L%C3%A9b%C3%A9-456315311052792/?hc_location=ufi&rf=350047908853197"
          target="_blank" rel="noopener">
          <i class="fab fa-facebook fa-2x" style="color:#3b5998"></i>
        </a>

        <p>
          Réalisation
          <a href="https://www.graphibox.biz/" target="_blank" rel="noopener" title="Graphibox">Graphibox</a> - Tous
          droits réservés
        </p>
      </div>
    </footer>



    <Cookies color_one="var(--dark-color)" color_two="var(--main-color)"></Cookies>
  </div>
</template>

<script>
import PhoneBurger from "@/components/PhoneBurger";
import Cookies from "@/components/Cookies";

export default {
  data() {
    return {
      showMenu: true,
      windowWidth: 0,
      showReservation: true,
    };
  },
  components: {
    PhoneBurger,
    Cookies,
  },
  beforeCreate() {
    this.$store.commit("getArticles");
  },
  created() {
    document.addEventListener("scroll", this.onScroll);
    // this.getAgenda();
  },
  destroyed() {
    document.removeEventListener("scroll", this.onScroll);
  },
  mounted() {
    this.showMenu = false;

    // this.$nextTick(() => {
    //   this.getAgenda();
    // });

    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });



  },
  watch: {},

  methods: {
    hideMenuPhone() {
      if (window.innerWidth < 1000) {
        this.showMenu = false;
      }
    },
    isAerodrome() {
      if (window.location.pathname == "/aerodrome") {
        return true;
      }
    },

    onScroll() {
      let imgEl = document.getElementById("imgLogo");
      if (window.scrollY >= 150) {
        imgEl.style.width = "50px";
        document.getElementById("nav").style.padding = "4px 0";
        document.getElementById("nav").style.boxShadow = "0px 0px 8px 0px #ccc";
      } else if (window.scrollY <= 70) {
        imgEl.style.width = "120px";
        document.getElementById("nav").style.padding = "1rem 0";
        document.getElementById("nav").style.boxShadow = "unset";
      }
    },
    // getAgenda() {
    //   widgetItea("dispo", "crlu1u77", "32G200019"); /*Le gite  */
    //   widgetItea("dispo", "crlu1u77", "32G500409"); /**Le studio */

    //   let myIframe = document
    //     .getElementsByTagName("iframe")[0]
    //     .classList.contains("mapIframe")
    //     ? 1
    //     : 0;
    //   document
    //     .getElementsByClassName("resaGite")[0]
    //     .appendChild(document.getElementsByTagName("iframe")[myIframe]);

    //   myIframe = document
    //     .getElementsByTagName("iframe")[1]
    //     .classList.contains("mapIframe")
    //     ? 2
    //     : 1;
    //   document
    //     .getElementsByClassName("resaStudio")[0]
    //     .appendChild(document.getElementsByTagName("iframe")[myIframe]);
    //   this.showReservation = false;
    // },
  },
};
</script>


<style>
@font-face {
  font-family: "Muti";
  src: url("~@/assets/fonts/Muli-VariableFont_wght.ttf") format("truetype");
  font-display: swap;
}

@font-face {
  font-family: "Dancing";
  src: url("~@/assets/fonts/DancingScript-VariableFont_wght.ttf") format("truetype");
  font-display: swap;
}

:root {
  --main-color: #a8be50;
  --dark-color: #5c884a;
}

body,
html {
  padding: 0;
  margin: 0;
  scroll-behavior: smooth;
}

.wow {
  visibility: hidden;
}

#app {
  font-family: "Muti", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

a {
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  color: #111;
}

#app {
  position: relative;
}

#nav {
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  padding: 1rem 0;
  background: white;
  z-index: 10;
}

#nav>div {
  width: 45%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

#nav span {
  color: var(--main-color);
  font-size: 2rem;
}

#nav a.router-link-exact-active {
  color: var(--main-color);
}

#nav .epi.router-link-exact-active {
  color: rgb(238, 120, 84);
}

#nav a {
  transition: 0.3s ease;
}

#nav a:hover {
  color: var(--main-color);
  transition: 0.3s ease;
}

#nav img {
  width: 120px;
  transition: 0.3s ease;
}

.absoGreenBar.barBottom {
  position: absolute;
  height: 160px;
  bottom: 0;
  width: 100%;
}

h2.titlePage {
  color: var(--dark-color);
  margin: 0;
  font-size: 3.5rem;
  font-weight: normal;
  word-spacing: 2px;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  font-variation-settings: "wght" 1000;
}

h2.titlePage strong {
  font-size: 3rem;
  line-height: 0;
  padding-bottom: 1.6rem;
  margin: 0 12px;
}

.fade-enter-active {
  transition: all 0.4s;
}

.fade-leave-active {
  transition: all 0.2s;
}

.fade-leave-to {
  opacity: 0;
}

.fade-enter {
  transform: scale(0) translateY(-50%);
  opacity: 0;
}

.giteContainer {
  margin: 0 12%;
}

.fioriture {
  width: 2px;
  height: 100px;
  background: rgb(214, 236, 224);
  margin: 1rem auto;
}

.avion {
  position: relative;
  text-align: center;
}

.avion img {
  width: 100%;
  display: block;
}

.avion div {
  position: absolute;
  text-align: center;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avion h3 {
  margin: 7% 0 3%;
  font-size: 3rem;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
  font-variation-settings: "wght" 100;
}

.avion p {
  font-size: 1.5rem;
  margin-top: auto;
}

.avion span {
  /* background: #fff; */
  padding: 4px;
  line-height: 2.4rem;
  text-shadow: 0px 0px 5px white;
}

footer {
  background: url("assets/images/background/footerbkg.jpg") no-repeat;
  background-size: cover;
  background-position: 0 80%;
  padding: 1rem;
  padding-bottom: 2rem;
}

footer>section {
  display: flex;
  justify-content: space-evenly;
  text-align: center;
}

footer p,
footer a {
  margin: 0.5rem 0;
  font-size: 1.1rem;
  color: #111;
}

footer a:hover {
  color: var(--main-color);
}

footer h4 {
  color: var(--dark-color);
  font-size: 1.9rem;
  margin: 8px 0;
  font-weight: 300;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
  font-variation-settings: "wght" 1000;
}

footer ul {
  list-style: none;
  padding: 0;
}

.navImg {
  background: rgba(168, 190, 80, 0.8);
  padding: 0.5rem 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.navImg a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.navImg p {
  margin: 0.2rem 0;
}

.navImg strong {
  font-weight: normal;
  font-size: 1.8rem;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
  font-variation-settings: "wght" 1000;
}

.greenBtn {
  display: table;
  padding: 1rem 1.5rem;
  text-transform: uppercase;
  border: 2px var(--dark-color) solid;
  color: var(--dark-color);
  font-weight: bold;
  transition: all 0.3s ease;
  white-space: nowrap;
  margin-top: 2rem;
}

.greenBtn:hover {
  background-color: var(--dark-color);
  color: white;
  font-weight: 600;
}

.logosPartner {
  display: flex;
  justify-content: flex-end;
  padding-right: 17%;
}

.logosPartner img {
  height: 40px;
  margin: 0 8px;
}

.copyright {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 0 10%;
}

.copyright>* {
  flex: 1;
  margin: 0;
  text-align: center;
  font-size: 0.9rem;
}

.copyright p {
  font-style: italic;
}

.greenLink {
  color: var(--main-color);
  margin-top: 1rem;
}

.phoneLogo {
  display: none;
}

.actuSection {
  text-align: center;
  margin-top: 3rem;
  margin-bottom: 2rem;
}

.actuSection>p {
  font-size: 1.4rem;
  margin-bottom: 0.3rem;
  text-transform: uppercase;
}

.actuSection>h3 {
  font-size: 3.2rem;
  margin: 0 0 1rem;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
  font-variation-settings: "wght" 1000;
}

.actuSection>h3 strong {
  font-size: 3rem;
  line-height: 0;
  padding-bottom: 1.2rem;
  margin: 0 12px;
}

.actuSection .scrollX>div {
  display: flex;
  justify-content: center;
  margin-top: 3rem;
}

.actuSection article {
  width: 18vw;
  margin: 0 1vw;
  text-align: left;
  cursor: pointer;
  transition: 0.3s ease;
}

.actuSection article:hover {
  box-shadow: 1px 1px 6px 2px lightgray;
  transition: 0.5s ease;
}

.actuSection article img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.actuSection span {
  color: var(--main-color);
  text-transform: uppercase;
}

.actuSection article p {
  font-weight: 500;
  font-size: 1.05rem;
  padding: 0.5rem;
}

.hebItem {
  position: relative;
  width: 99vw;
  height: 95vh;
  display: flex;
  overflow: hidden;
}

.hebItem img {
  width: 80%;
  max-width: unset;
  object-fit: cover;
}

.reverseHebItem img {
  margin-left: 20%;
}

.absoInfos {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 55%;
  padding-right: 5%;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 38%,
      rgba(255, 255, 255, 1) 100%);
}

.absoInfos .important {
  font-weight: bold;
  font-size: 1.1rem;
}

.absoInfos h3 {
  font-size: 3rem;
  color: var(--dark-color);
  margin-top: 1rem;
  margin-bottom: 3rem;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
  font-variation-settings: "wght" 500;
  width: 50%;
  margin-left: auto;
}

.absoInfos p {
  font-size: 1.1rem;
  margin: 0;
  margin-left: auto;
  width: 50%;
}

.absoInfos .greenBtn {
  transform: none;
  margin-left: 50%;
}

.absoInfosLeft {
  right: unset;
  left: 0;
  padding-left: 5%;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 42%,
      rgba(255, 255, 255, 0) 100%);
}

.absoInfosLeft .greenBtn,
.absoInfosLeft h3,
.absoInfosLeft p {
  margin-left: 0;
}

.reservationBox {
  position: fixed;
  right: 0;
  /* top: 35%; */
  bottom: 5%;
  width: 900px;
  max-width: 100%;
  background: white;
  z-index: 2;
  box-shadow: 0 0 25px 0 #aaa;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.reservationBox>i {
  display: none;
}

.reservationBox .titlePage {
  font-size: 2rem;
  margin: 1rem 0;
}

.reservationBox>div {
  max-width: 31%;
  margin: 0 1%;
}

.reservationBox .resaChHotes,
.reservationBox iframe {
  height: 270px;
}

.behindReservation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.5);
}

.btnBox {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 70px;
}

.btnBox .greenBtn {
  z-index: 4;
}

@media all and (max-width: 1500px) {
  .actuSection article {
    width: 25vw;
  }
}

@media all and (max-width: 1100px) {
  #nav img {
    width: 80px;
  }

  #nav a {
    font-size: 0.9rem;
  }

  .fioriture {
    display: none;
  }

  .actuSection article {
    width: 31vw;
  }
}

@media all and (max-width: 990px) {
  #nav img {
    width: 80px;
  }

  #nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    z-index: 8;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  #nav a {
    margin: 1rem 0;
    font-size: 2rem;
  }

  #nav>div {
    flex-direction: column;
    width: unset;
  }

  .phoneLogo {
    display: block;
    width: 100%;
    text-align: center;
  }

  .phoneLogo img {
    width: 100px;
    margin-top: 1rem;
  }

  .avion p {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media all and (max-width: 900px) {
  .avion h3 {
    margin: 2%;
    font-size: 2rem;
  }

  .reservationBox:nth-child(4) {
    width: 100%;
    max-width: unset;
    height: fit-content;
  }

  .reservationBox div {
    max-width: unset;
  }

  .reservationBox .resaChHotes {
    height: unset !important;
  }

  .reservationBox .btnBox .greenBtn {
    margin-top: 0;
  }
}

@media all and (max-width: 768px) {
  #nav a {
    margin: 0.5rem 0;
    font-size: 2rem;
  }

  #nav span {
    display: none;
  }

  .titlePage strong {
    display: none;
  }

  .actuSection .scrollX>div {
    width: fit-content;
    padding-bottom: 2rem;
    margin-top: 1rem;
  }

  .actuSection article {
    width: 55vw;
    box-shadow: 1px 1px 6px 2px lightgray;
  }

  .reservationBox {
    bottom: 0;
    top: 0;
    overflow: scroll;
  }

  .reservationBox>i {
    display: block;
    position: absolute;
    top: 8px;
    left: 8px;
    font-size: 2em;
  }
}

@media all and (max-width: 600px) {
  .avion img {
    height: 60vh;
    object-fit: cover;
    object-position: bottom right;
  }

  .avion p {
    margin-top: unset;
  }

  footer>section {
    flex-direction: column;
    text-align: left;
  }

  footer ul {
    margin-top: 0;
  }

  footer li {
    margin: 0 4px;
  }

  footer h4 {
    margin: 4px 0;
  }
}

.fade-enter-active {
  transition: opacity 2.5s;
}

.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.fromRight-enter-active {
  transition: all 0.7s;
}

.fromRight-leave-active {
  transition: all 0.5s;
}

.fromRight-enter,
.fromRight-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  transform: translateX(100%);
}

.textAppear-enter-active,
.textAppear-leave-active {
  transition: all 2.5s;
}

.textAppear-enter {
  opacity: 0;
  transform: translate(50%, -50%);
}

@media all and (max-width: 550px) {
  .actuSection article {
    width: 75vw;
  }
}

@media all and (max-width: 400px) {
  .actuSection>h3 {
    font-size: 11vw;
  }
}

.leftToRight {
  -webkit-animation: 2s linear 0s animLeftToRight;
  animation: 2s linear 0s animLeftToRight;
  z-index: 3;
}

.rightToLeft {
  -webkit-animation: 2s linear 0s animRightToLeft;
  animation: 2s linear 0s animRightToLeft;
  z-index: 3;
}

@-webkit-keyframes animLeftToRight {
  from {
    opacity: 0;
    transform: translate(50%, 0);
  }

  to {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@keyframes animLeftToRight {
  from {
    opacity: 0;
    transform: translate(50%, 0);
  }

  to {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@-webkit-keyframes animRightToLeft {
  from {
    opacity: 0;
    transform: translate(0, 0);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes animRightToLeft {
  from {
    opacity: 0;
    transform: translate(-50%, 0);
  }

  to {
    opacity: 1;
    transform: translate(0, 0);
  }
}
</style>